module.exports = __webpack_public_path__ + "media/images/zoom-030c53872068f657c768f8a1fee47313.png";